import axios from "../axiosPlugin.js";

const _ETHICAL_API = "/api/ethical";

export const getEthicalService = data => {
  return axios({
    url: `${_ETHICAL_API}/list`,
    method: "get",
    data: { data },
  });
};

export const getEthicalTagService = data => {
  return axios({
    url: "/api/ethicalTag/list",
    method: "get",
    data: {},
  })
}

export const updateEthicalService = data => {
  return axios({
    url: `${_ETHICAL_API}/update`,
    method: "post",
    data: { data },
  });
};
